const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export interface FaqCategory {
    id: number;
    name: string;
    color: string;
    icon: string | null;
    description: string | null;
}

export interface FaqArticle {
    id: number;
    title: string;
    slug: string;
    summary: string | null;
    content?: string;
    category: FaqCategory | null;
    viewCount: number;
    publishedAt: string | null;
    updatedAt: string | null;
}

export interface FaqGrouped {
    category: FaqCategory | null;
    articles: FaqArticle[];
}

export interface FaqResponse {
    grouped: FaqGrouped[];
    articles: FaqArticle[];
    categories: FaqCategory[];
    total: number;
}

class FaqService {
    private baseUrl = `${API_URL}/api/public`;

    async getCategories(): Promise<FaqCategory[]> {
        const response = await fetch(`${this.baseUrl}/faq/categories`);
        if (!response.ok) {
            throw new Error('Failed to fetch FAQ categories');
        }
        const data = await response.json();
        return data.categories;
    }

    async getFaqArticles(categoryId?: number, search?: string): Promise<FaqResponse> {
        const params = new URLSearchParams();
        if (categoryId) {
            params.append('category', categoryId.toString());
        }
        if (search) {
            params.append('q', search);
        }

        const url = `${this.baseUrl}/faq${params.toString() ? '?' + params.toString() : ''}`;
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error('Failed to fetch FAQ articles');
        }

        return response.json();
    }

    async getArticle(slug: string): Promise<FaqArticle> {
        const response = await fetch(`${this.baseUrl}/faq/${slug}`);

        if (!response.ok) {
            if (response.status === 404) {
                throw new Error('Article not found');
            }
            throw new Error('Failed to fetch article');
        }

        const data = await response.json();
        return data.article;
    }
}

export const faqService = new FaqService();
